export default __webpack_public_path__ + "static/media/templates.bed85e05.svg";